import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/imgs/logo_white.png';
const _withScopeId = n => (_pushScopeId("data-v-082edb2f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "bg-[#333A4A] py-[100px] mt-[-1px]"
};
const _hoisted_2 = {
  class: "mx-auto container px-5"
};
const _hoisted_3 = {
  class: "flex-1 flex justify-between flex-col md:flex-row gap-10"
};
const _hoisted_4 = {
  class: "flex-1 flex flex-col"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "w-[180px]",
  alt: "Safe",
  src: _imports_0
}, null, -1));
const _hoisted_6 = {
  class: "text-white6 text-sm mt-[65px]"
};
const _hoisted_7 = {
  class: "flex text-white6 justify-between gap-10"
};
const _hoisted_8 = {
  href: "https://messenger.mixin.one",
  target: "_blank"
};
const _hoisted_9 = {
  href: "http://t.me/MixinBot",
  target: "_blank"
};
const _hoisted_10 = {
  href: "https://mixpay.me/",
  target: "_blank"
};
const _hoisted_11 = {
  target: "_blank",
  href: "https://go.crisp.chat/chat/embed/?website_id=52662bba-be49-4b06-9edc-7baa9a78f714"
};
import { useI18n } from "vue-i18n";
export default /*#__PURE__*/_defineComponent({
  __name: 'Footer',
  setup(__props) {
    const {
      t
    } = useI18n();
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("footer", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("p", _hoisted_6, _toDisplayString(_unref(t)("footer.desc")), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString(_unref(t)("footer.partners.title")), 1), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_8, _toDisplayString(_unref(t)("footer.partners[0]")), 1)]), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_9, _toDisplayString(_unref(t)("footer.partners[1]")), 1)]), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_10, _toDisplayString(_unref(t)("footer.partners[2]")), 1)])]), _createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString(_unref(t)("footer.company.title")), 1), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/about"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)("footer.company[0]")), 1)]),
        _: 1
      })]), _createElementVNode("li", null, [_createElementVNode("a", _hoisted_11, _toDisplayString(_unref(t)("footer.company[1]")), 1)])]), _createElementVNode("ul", null, [_createElementVNode("li", null, _toDisplayString(_unref(t)("footer.legal.title")), 1), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/privacy_policy"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)("footer.legal[0]")), 1)]),
        _: 1
      })]), _createElementVNode("li", null, [_createVNode(_component_router_link, {
        to: "/service"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)("footer.legal[1]")), 1)]),
        _: 1
      })])])])])])]);
    };
  }
});